/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Resource_FieldInputs */

const en_admin_permissions_resource_field = /** @type {(inputs: Admin_Permissions_Resource_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource`)
};

/**
* | output |
* | --- |
* | "Resource" |
*
* @param {Admin_Permissions_Resource_FieldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_resource_field = /** @type {((inputs?: Admin_Permissions_Resource_FieldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Resource_FieldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_resource_field(inputs)
});
export { admin_permissions_resource_field as "admin.permissions.resource_field" }